<template>
  <v-chart class="chart" :option="option" />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
// import { getHeatingPower } from "@/api/api.js";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);
var data = [15, 40, 20, 52, 27];
export default {
  components: {},
  props: ["data"],
  data() {
    return {
      option: {
        tooltip: {},
        timer: 0,
        grid: {
          x: 30,
          y: 20,
          x2: 0,
          y2: 30,
        },
        xAxis: {
          type: "category",
          data: ["浙江", "上海", "江苏", "安徽", "广东"],
          axisLine: {
            lineStyle: {
              color: "#103e4f",
              fontSize: "16",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#a3fffe",
          },
        },
        yAxis: {
          max: 999,
          type: "value",
          interval: 300,
          axisTick: false,
          splitLine: {
            lineStyle: {
              color: "#103e4f",
            },
          },
          axisLabel: {
            color: "#a3fffe",
          },
        },
        series: [
          {
            name: "人流来源省份情况",
            data: data,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(132, 178, 197, 0.3)",
              borderRadius: [15, 15, 15, 15],
            },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                },
              },
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgb(0, 255, 255)",
                  },
                  {
                    offset: 1,
                    color: "rgb(0, 175, 248)",
                  },
                ],
                globalCoord: false,
              },
              borderRadius: [15, 15, 15, 15],
            },
            barMaxWidth: 17,
            // barCategoryGap: "20",
          },
        ],
      },
    };
  },
  methods: {
    getData() {
      const _data = [
         { name: '浙江', value: this.random_number(100, 300) },
         { name: '上海', value: this.random_number(100, 200) },
         { name: '江苏', value: this.random_number(50, 100) },
         { name: '安徽', value: this.random_number(40, 90) },
         { name: '广东', value: this.random_number(20, 50) },
      ]

      this.option.series[0].data = _data
      this.option.xAxis.data = _data.map((item) => { return item.name })
      // getHeatingPower().then((res) => {
      //   res.data.data.province_count.data.sort(function (a, b) { return b.data_num - a.data_num })
      //   this.option.series[0].data = res.data.data.province_count.data.slice(0, 8).map((o) => {
      //       return { name: o.data_name, value: o.data_num }
      //     })
      //   this.option.xAxis.data = res.data.data.province_count.data
      //     .slice(0, 8)
      //     .map((o) => {
      //       return { value: o.data_name }
      //     })
      //   return
      // })
    },
  },
  mounted() {
    this.getData();
    this.timer = setInterval(this.getData, 6000)
  },
};
</script>

<style scoped></style>
